import React, { useState } from "react";

const COLORS = {
  orange: "#E87E04",
  white: "#FFFFFF",
  green: "#008751",
  darkGreen: "#006B3F",
  lightOrange: "#FFE0B2",
  lightGreen: "#CCFFCC",
  gray: "#718096",
};

const ShippingRatesManager = ({
  setSelectedOriginZone,
  selectedOriginZone,
  packageDimensions,
  setPackageDimensions,
}) => {
  const [activeTab, setActiveTab] = useState("dimensions");

  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 bg-white shadow-lg rounded-xl border border-gray-100">
      <h2
        className="text-xl sm:text-2xl font-bold mb-6"
        style={{ color: COLORS.darkGreen }}
      >
        Gestion des Dimensions et Zone d'Origine
      </h2>

      {/* Tabs - version moderne avec couleurs personnalisées */}
      <div
        className="flex mb-6 p-1 rounded-lg"
        style={{ backgroundColor: COLORS.lightGreen }}
      >
        {["dimensions"].map((tab) => (
          <span
            key={tab}
            className="flex-1 py-3 px-4 text-sm font-medium transition-all duration-200 rounded-lg"
            style={{
              backgroundColor: activeTab === tab ? COLORS.green : "transparent",
              color: activeTab === tab ? COLORS.white : COLORS.darkGreen,
              boxShadow:
                activeTab === tab ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none",
              cursor: "pointer",
            }}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "dimensions" ? "Dimensions du Colis" : "Zone d'Origine"}
          </span>
        ))}
      </div>

      {/* Contenu des onglets */}
      {activeTab === "origin" && (
        <div className="mb-4 transition-all duration-300 ease-in-out">
          <div className="space-y-2">
            <label
              className="block text-sm font-medium"
              style={{ color: COLORS.gray }}
            >
              Zone d'Origine
            </label>
            <input
              type="text"
              className="w-full p-3 border rounded-lg transition-all duration-200"
              style={{
                backgroundColor: COLORS.lightOrange,
                borderColor: COLORS.orange,
                color: COLORS.darkGreen,
              }}
              value={selectedOriginZone}
              onChange={(e) => setSelectedOriginZone(e.target.value)}
              placeholder="Entrez votre zone d'origine"
            />
          </div>
        </div>
      )}

      {/* Onglet Dimensions */}
      {activeTab === "dimensions" && (
        <div className="transition-all duration-300 ease-in-out">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label
                className="block text-sm font-medium"
                style={{ color: COLORS.gray }}
              >
                Poids (kg)
              </label>
              <div className="relative">
                <input
                  type="number"
                  value={packageDimensions?.weight || ""}
                  onChange={(e) =>
                    setPackageDimensions((prev) => ({
                      ...prev,
                      weight: Number(e.target.value),
                    }))
                  }
                  className="w-full p-3 border rounded-lg transition-all duration-200"
                  style={{
                    backgroundColor: COLORS.lightGreen,
                    borderColor: COLORS.green,
                    color: COLORS.darkGreen,
                  }}
                  step="0.1"
                  placeholder="0.0"
                />
                <span
                  className="absolute right-3 top-1/2 transform -translate-y-1/2"
                  style={{ color: COLORS.gray }}
                >
                  kg
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShippingRatesManager;
